<script setup>
useHead({
  title: 'CanXChange', // Change useTalkjsSessionInitializer title as well.
  meta: [
    {
      name: 'description',
      content: 'CanXChange PWA Application',
    },
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0, viewport-fit=cover', // viewport-fit=cover is for iPhone, ref: https://daisyui.com/components/bottom-navigation/
    },
  ],
  link: [
    {
      rel: 'icon',
      type: 'image/x-icon',
      href: '/favicon.ico',
      sizes: '48x48',
    },
    {
      rel: 'stylesheet',
      href: 'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200&display=block',
    },
    {
      rel: 'apple-touch-icon',
      href: '/apple-touch-icon-180x180.png',
    },
  ],
  script: [
    {
      src: 'https://cdn.jsdelivr.net/npm/vue@3',
      type: 'text/javascript',
    },
  ],
})
const { isMobile } = useDevice()
const { $pwa, $logger } = useNuxtApp()

// const toast = useToast()
onMounted(() => {
  if ($pwa.offlineReady) {
    $logger.log('App is ready to work offline')
  }
})
</script>

<template>
  <NuxtPwaManifest />
  <NuxtLoadingIndicator
    color="repeating-linear-gradient(to right,rgb(var(--primary-500)) 0%,rgb(var(--accent)) 100%)"
    :height="6"
  />
  <ConfirmDialog
    :draggable="false"
    class="w-[95vw] md:w-[50vw]"
  />
  <DynamicDialog />
  <Toast :position="isMobile ? 'top-center' : 'top-right'" />
  <Suspense>
    <NuxtLayout>
      <NuxtPage :page-key="route => route.fullPath" />
    </NuxtLayout>
    <template #fallback>
      <div class="h-full flex justify-center items-center">
        <SpinningLoader class="h-28 w-full" />
      </div>
    </template>
  </Suspense>
</template>

<style>
.material-symbols-outlined {
  font-variation-settings:
  'FILL' 0,
  'wght' 400,
  'GRAD' 0,
  'opsz' 24
}
</style>
